const shouldRenderYouTubeVideos = () => {
    const hostname = window.location.hostname;
    return hostname !== "ndnc.jazzesl.com.pk";
};

export default shouldRenderYouTubeVideos;